import { useState, useEffect } from "react";
import { ArrowBigUp } from "lucide-react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", 
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <button
      className={`${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } fixed bottom-8 right-8 bg-primary hover:bg-secondary text-white hover:text-primary p-3 rounded-full shadow-lg transition-opacity duration-300 ease-in-out z-50`}
      onClick={scrollToTop}
    >
      <ArrowBigUp />
    </button>
  );
};

export default ScrollToTopButton;
